module.exports = __webpack_public_path__ + "media/components/common/formParts/icons/Info-297503796a267c0a164de0011a32f83e.svg";